import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Alert from '@components/Alert/Alert';

import { useCheckConsent } from '@hooks/useCheckConsent';
import { useSession } from '@hooks/useSession';

import { formatName } from '@utils/format';

const messages = defineMessages({
  missingConsent: {
    id: 'alert.consent.missingConsent',
    defaultMessage: '{name} is missing consent(s): {consents} to process PHI',
  },
  acceptConsent: {
    id: 'alert.consent.acceptConsent',
    defaultMessage:
      '{name} needs to accept these consents in order to use and receive VITALL services',
  },
  toc: {
    id: 'GLOBAL.toc',
    defaultMessage: 'Terms and Conditions',
  },
  vitallConsent: {
    id: 'GLOBAL.vitallConsent',
    defaultMessage: 'VITALL Consent',
  },
});

export default function ConsentAlert() {
  const { formatMessage } = useIntl();
  const {
    state: { activeProfile },
  } = useSession();
  const {
    data: { tocPnConsented, vitallConsented, hasConsented },
  } = useCheckConsent();

  return (
    <Alert
      severity="warning"
      sx={{ borderRadius: 0 }}
      title={formatMessage(messages.missingConsent, {
        name: formatName(activeProfile?.first_name, activeProfile?.last_name),
        consents: [
          ...(tocPnConsented ? [] : [formatMessage(messages.toc)]),
          ...((typeof vitallConsented === 'boolean' && !vitallConsented) ||
          (typeof hasConsented === 'boolean' && !hasConsented)
            ? [formatMessage(messages.vitallConsent)]
            : []),
        ].join(', '),
      })}
    >
      {formatMessage(messages.acceptConsent, {
        name: activeProfile?.first_name,
      })}
    </Alert>
  );
}
